
import initialState from './initialState'

const mutations = {
  setCollection(state, payload) {
    state.collection = payload
  },
  setOffice(state, payload) {
    state.office = payload
  },
  setIsOfficeLoading(state, payload) {
    state.isOfficeLoading = payload
  },
  setIsCollectionLoading(state, payload) {
    state.isCollectionLoading = payload
  },
  clearOfficeData() {
    this.state.contacts.office = initialState().office
  }
}

export default mutations